import DealsPromotions from './DealsPromotions'
// import { Routes } from 'app/services/routeService/routeService';
import { AccessType } from 'app/auth/accessControlService'

import Redemption from 'app/main/dealsPromotions/redemption/Redemption'
import DealPromotionPage from 'app/main/dealsPromotions/DealPromotionPage'

export const subRoutes = [
  {
    path: '/deals-promotions',
    component: DealPromotionPage,
    accesses: [AccessType.NOTIFICATION_VIEW_OWNED, AccessType.ADMINISTRATION],
    routes: [
      {
        exact: true,
        path: '/deals-promotions',
        component: DealsPromotions,
        accesses: [
          AccessType.NOTIFICATION_VIEW_OWNED,
          AccessType.ADMINISTRATION,
        ],
      },
      {
        exact: true,
        path: '/deals-promotions/redemption',
        component: Redemption,
        accesses: [
          AccessType.ADMINISTRATION,
          AccessType.NOTIFICATION_VIEW_OWNED,
          AccessType.NOTIFICATION_VIEW_ALL,
          AccessType.SUBSCRIBER_VIEW,
        ],
      },
    ],
  },
]

export const DealsPromotionsConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: subRoutes,
}
